<template>
  <div>
    <v-file-input
      show-size
      label="File input"
      @change="previewImage"
      accept="image/*"
      v-model="file"
      prepend-icon="mdi-camera"
    ></v-file-input>
    <div v-if="imageData || imgPreview != null" class="mt-8">
      <v-progress-linear
        :value="uploadValue"
        v-if="imageData"
      ></v-progress-linear>
      <div class="preview mt-8">
        <img class="" :src="imgPreview" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");

export default {
  name: "Upload",
  data() {
    return {
      imageData: null,
      picture: null,
      uploadValue: 0,
      file: null,
      files: [],
    };
  },
  props: ["value", "preview"],
  computed: {
    imgPreview() {
      if (this.picture) {
        return this.picture;
      } else if (this.preview) {
        return this.preview.src;
      } else {
        return null;
      }
    },
  },
  methods: {
    previewImage: function() {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      this.onUpload();
    },
    onUpload() {
      this.picture = null;
      const storageRef = fb.storage
        .ref(`${this.imageData.name}`)
        .put(this.imageData);
      storageRef.on(
        "state_changed",
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.warn(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.picture = url;
            this.$emit("updatedSrc", url);
          });
          storageRef.snapshot.ref.getMetadata().then((doc) => {
            this.$emit("updateTitle", doc.name);
          });
        }
      );
    },
  },
};
</script>

<style scoped="">
.preview {
  width: 100%;
  height: 20rem;
  width: 20rem;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
